jQuery(function($){
    var slideAbout = $('.slides-about');
    if(slideAbout.length){
        slideAbout.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            prevArrow: '<button type="button" class="slick-prev btn btn-link fs-3 p-1" aria-label="Previous"><i class="bi bi-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-link fs-3 p-1" aria-label="Next"><i class="bi bi-chevron-right"></i></button>',
        });
    }
});